module.exports = __webpack_public_path__ + "img/awards_chip1.471deb0b.png";